import { FormizoSchema } from "Components/LabIZO/Formizo/FormizoSchema.interface";

export const SpecialAnswerSetting: FormizoSchema[] = [
  {
    header: "Digit Query",
  },
  {
    label: "TC",
    name: "SettingDoc.Config.digitQuery.TC",
    format: "textarea",
    variant: "outlined",
  },
  {
    label: "SC",
    name: "SettingDoc.Config.digitQuery.SC",
    format: "textarea",
    variant: "outlined",
  },
  {
    label: "EN",
    name: "SettingDoc.Config.digitQuery.EN",
    format: "textarea",
    variant: "outlined",
  },
];
